module.exports = __webpack_public_path__ + "img/FA2.05534bec.png";